import * as React from 'react';
export const unicreditSvg = React.forwardRef(function unicreditSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement(
      'g',
      {
        clipPath: 'url(#bi_unicredit__a)',
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M26.182 16c0 5.623-4.559 10.182-10.182 10.182S5.818 21.624 5.818 16c0-5.623 4.559-10.182 10.182-10.182S26.182 10.377 26.182 16Z',
        fill: 'url(#bi_unicredit__b)',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M15.138 10.618c.212.162 1.278.786 1.6.985l.109.079.052-.08c.114-.187.157-.336-.161-.536-.319-.199-1.385-.823-1.6-.986l-.348-.28a2.5 2.5 0 0 0 .348.818Z',
        fill: '#4B4B4D',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M15.356 13.174s1.175-1.521 1.289-1.709c.113-.188.155-.338-.163-.537-.319-.199-1.384-.822-1.6-.984-.217-.163-.173-.761.45-.886a52.82 52.82 0 0 1 8.146-.35c2.108.225 1.917.987 1.833 1.31-.122.471-.85 1.185-1.996 2.22 0 0-1.89 1.76-3.28 2.97-1.389 1.21-5.818 4.938-6.673 5.613-.856.674-4.198 3.156-4.412 3.325-.214.168-.822.65-1.152.311-.33-.339 0-.719.167-.951.168-.233 6.892-9.727 7.39-10.328',
        fill: '#fff',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M25.183 9.286c.094.23.138.478.13.727-.122.472-.849 1.186-1.995 2.221 0 0-1.891 1.759-3.28 2.97-1.39 1.21-5.818 4.937-6.674 5.612-.855.675-4.2 3.161-4.414 3.33a3.21 3.21 0 0 1-1.223.22c.147.181.308.349.482.503.34.328.936-.146 1.152-.312.217-.165 3.554-2.653 4.415-3.32.861-.668 5.289-4.405 6.674-5.613 1.384-1.21 3.28-2.97 3.28-2.97 1.146-1.035 1.773-1.6 1.89-2.069a1.22 1.22 0 0 0-.436-1.295',
        fill: 'url(#bi_unicredit__c)',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'radialGradient',
        {
          id: 'bi_unicredit__b',
          cx: 0,
          cy: 0,
          r: 1,
          gradientUnits: 'userSpaceOnUse',
          gradientTransform: 'translate(12.136 10.574) scale(8.80145)',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#FFEBE3',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.147,
          stopColor: '#F39672',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.366,
          stopColor: '#E2001A',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.708,
          stopColor: '#CF001A',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.842,
          stopColor: '#AF0819',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#B30414',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_unicredit__c',
          x1: 14.425,
          y1: 32.493,
          x2: 31.872,
          y2: 17.08,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#464648',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.049,
          stopColor: '#464648',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.095,
          stopColor: '#919294',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.155,
          stopColor: '#464648',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.906,
          stopColor: '#515153',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.96,
          stopColor: '#919294',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.984,
          stopColor: '#515153',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#515153',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: 'bi_unicredit__a',
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#fff',
          transform: 'translate(5.818 5.818)',
          d: 'M0 0h20.364v20.364H0z',
        }),
      ),
    ),
  );
});
unicreditSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var unicredit = {
  category: 'brand',
  colorable: false,
  name: 'unicredit',
  svg: unicreditSvg,
};
